export default __webpack_public_path__ + "static/media/Suggestedads.fe37edee.svg";